import React from 'react';
import { motion } from 'framer-motion';
import { ParallaxSection } from './ParallaxSection';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/6ZAynorNPQnLfz6RriyKNX/vitaly-gariev-XV27HoZzYK8-unsplash.jpg';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/58ujAQtekwQT37CqH9LFPA/prime_nation_transparent_bg.png';
export function Hero() {
  return <ParallaxSection bgImage={HERO_BG} overlayOpacity={0.75} className="min-h-[100svh] pt-[60px] md:pt-[64px]" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-[120px] md:py-[160px] flex flex-col items-center text-center" data-id="element-81">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-brand-gold font-bold tracking-[0.2em] uppercase text-sm md:text-base mb-4" data-id="element-82">
          Serving Communities Since 2009
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-white text-[32px] md:text-[56px] leading-[1.1] font-serif mb-6 max-w-4xl text-shadow-lg" data-id="element-83">
          Free Essentials. Real Connection. Built for the People.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-white/90 text-base md:text-lg max-w-[600px] mb-10 leading-relaxed text-shadow-md" data-id="element-84">
          Free phones, free tablets, free home internet, and free healthcare
          insurance for qualifying households. Prime Nation connects you to
          government-assisted resources you already qualify for.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col md:flex-row gap-3 md:gap-4 w-full md:w-auto" data-id="element-85">
          <button className="w-full md:w-auto bg-brand-gold text-brand-black px-8 py-4 rounded font-bold text-base hover:bg-yellow-500 transition-colors min-h-[52px] flex items-center justify-center" data-id="element-86">
            See If You Qualify
          </button>
          <button className="w-full md:w-auto bg-transparent border-2 border-brand-gold text-white px-8 py-4 rounded font-bold text-base hover:bg-brand-gold/10 transition-colors min-h-[52px] flex items-center justify-center" data-id="element-87">
            Browse Services
          </button>
        </motion.div>
      </div>
    </ParallaxSection>;
}